import { render, staticRenderFns } from "./homeNavigationMobile2.vue?vue&type=template&id=568c7a01&scoped=true"
import script from "./homeNavigationMobile2.vue?vue&type=script&lang=js"
export * from "./homeNavigationMobile2.vue?vue&type=script&lang=js"
import style0 from "./homeNavigationMobile2.vue?vue&type=style&index=0&id=568c7a01&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "568c7a01",
  null
  
)

export default component.exports